// Format date to a more readable format
export const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', options);
};

// Filter family members by search term
export const filterMembersBySearchTerm = (members, searchTerm) => {
    if (!searchTerm) return members;

    const term = searchTerm.toLowerCase();
    return members.filter(member =>
        member.name.toLowerCase().includes(term) ||
        member.occupation.toLowerCase().includes(term) ||
        member.location.toLowerCase().includes(term) ||
        member.branch.toLowerCase().includes(term)
    );
};

// Filter family members by branch
export const filterMembersByBranch = (members, branch) => {
    if (branch === 'all') return members;
    return members.filter(member => member.branch === branch);
};

// Sort events by date
export const sortEventsByDate = (events, ascending = true) => {
    return [...events].sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        return ascending ? dateA - dateB : dateB - dateA;
    });
};

// Check if an event is in the past
export const isEventInPast = (eventDate) => {
    const today = new Date();
    const date = new Date(eventDate);
    return date < today;
};

// Generate a unique ID for new items
export const generateId = () => {
    return Math.random().toString(36).substr(2, 9);
};

// Format phone number
export const formatPhoneNumber = (phoneNumber) => {
    const cleaned = ('' + phoneNumber).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return phoneNumber;
};

// Calculate age from birth date
export const calculateAge = (birthDate) => {
    const today = new Date();
    const birth = new Date(birthDate);
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
        age--;
    }

    return age;
};

// Truncate text with ellipsis
export const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) return text;
    return text.substr(0, maxLength) + '...';
};